import Button from "@/components/button/Button"
import { useGlobalContext } from "@/components/context/GlobalContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import OrgItem from "@/components/modal-dark/modal-dark-platform-content/choose-portal/OrgItem"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useOrganizationsGeneralInfoQuery, useResendEmailConfirmationOnLoginMutation } from "@/graphql"
import { ChoosePortalContent } from "@/helpers/orgSession"
import { websiteRoutes } from "@/router/routes"
import { EASETECH, WAYLEAVE } from "@/utilities/global-variables"
import { Col, Row, Skeleton, Space, message } from "antd"
import { FC } from "react"
import { useNavigate, useParams } from "react-router-dom"
import "./ChoosePortal.less"

const { Title, Paragraph } = WebsiteTypography

const ChoosePortal: FC = () => {
  const navigate = useNavigate()
  const { website } = websiteRoutes

  const { orgIds } = useGlobalContext()
  const { setIsModalDarkOpen, modalDarkContent } = useModalDarkContext()
  const { nextStep } = (modalDarkContent ?? {}) as ChoosePortalContent
  const isForgotPassword = nextStep === "forgot-password"
  const { org, portal } = useParams()
  const currentOrgSlug = org || EASETECH

  const { data, loading } = useOrganizationsGeneralInfoQuery({
    variables: { filter: { id: { in: orgIds } } },
  })

  const orgData = data?.organizations?.data as OrganizationEntity[]

  const handleRegister = () => {
    setIsModalDarkOpen(false)
    navigate(`/${currentOrgSlug}${website.auth}/${portal}/client`)
  }
  const handleOrgSelect = (slug: Maybe<string>) => {
    setIsModalDarkOpen(false)
    if (isForgotPassword) {
      navigate(`/${slug}${website.auth}/${portal || WAYLEAVE}/forgot-password`)
      return
    }
    // navigate(`/${slug}${website.auth}/login`)
    navigate(`/${slug}/home`)
  }

  const explanation = isForgotPassword
    ? "This email address has no account on this portal, but it is registered on the portal(s) below.\n" +
      "Accounts are separate for each organization. Choose your portal to reset your password there."
    : "Your email address is not linked to this Wayleave portal.\n" +
      "This usually happens when the incorrect portal URL is used. Please choose the portal you intended to access below and try again."

  return (
    <Row justify={"center"} className={"choose-portal-wrapper"} style={{ paddingTop: 24, paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={3} centered className={"section-title"}>
          <span className={"w300"}>{"Check Your "}</span>
          <span className={"bold"}>{"Portal Selection"}</span>
        </Title>

        {/*<Row justify={'center'}>*/}
        {/*  <div className={'hex-wrapper'}>*/}
        {/*    <SvgIcon type={'envelope-with-lock'} />*/}
        {/*  </div>*/}
        {/*</Row>*/}

        <Row justify={"center"}>
          <Col span={18}>
            <Paragraph
              centered
              size={"md"}
              style={{ paddingTop: 24, paddingBottom: 24 }}
              color={"website-secondary"}
              weight={"w300"}
            >
              {explanation}
            </Paragraph>
          </Col>
        </Row>
        <Row style={{ marginBottom: 24 }} className={"org-items-container"}>
          <Space direction={"vertical"} style={{ width: "100%" }}>
            {loading ? (
              <Skeleton loading paragraph={{ rows: 3 }} />
            ) : (
              orgData?.map(it => (
                <Col span={24} key={it?.id}>
                  <OrgItem it={it} onClick={handleOrgSelect} />
                </Col>
              ))
            )}
          </Space>
        </Row>
      </Col>

      <Row justify={"center"} className={"divider-with-hex"} style={{ margin: "0 0 24px 0" }}>
        <div className={"hex-small"} />
      </Row>

      <Row justify={"center"}>
        <Paragraph weight={"w300"} size={"sm"} color={"website-secondary"}>
          {"If you are new to this portal, you can register a new account."}
        </Paragraph>
      </Row>

      <Col span={24} style={{ paddingTop: 32 }}>
        <Row justify={"center"}>
          <Button btnType={"primary"} text={"REGISTER"} onClick={handleRegister} />
        </Row>
      </Col>
    </Row>
  )
}

export default ChoosePortal
